import * as SL from "./includes/_storeLocator";
import * as front from "./includes/_frontEndBehavior";
import * as access from "./includes/_accessibility";
import * as geoLoc from "./includes/_geolocalisation";
import * as tool from "./includes/_tools";

import {jobSlider} from "./includes/_job-slider";
import {avisSlider} from "./includes/_avis-slider";
import {remonteePagesSlider} from "./includes/_remontee-pages-slider";
import {agence} from "./includes/_agence";
import {storeUtmParameters} from "./includes/_utm-cookie";
import * as FSM from "./includes/_formStepManager";

const ajaxUrl = variables.ajax_url;
document.addEventListener("DOMContentLoaded", (formField, submit) => {
    //fonctions générales
    jobSlider();
    avisSlider();
    remonteePagesSlider();
    agence();
    storeUtmParameters();

    access.accessibility();
    access.toggleAccessibilityBtn();
    access.accessibilityBehavior();
    access.highContrast();
    access.fixAccessibilityGrayScale();

front.hideBannerOffreMenage();
    front.hideInputCityClickOutside();
    front.btnScrolltop();
    front.scrollIfAccordionNotVisible();
    front.initCommentCaMarcheSlider();
    front.initCarouselServiceSlider();
    if (window.matchMedia("(min-width: 768px)").matches) {
        front.addOpacityOnClickMegamenu();
    }
    if (window.matchMedia("(min-width: 1025px)").matches) {
        front.handleFixedHeader();
    }

    //a ranger
    front.allowControlCarouselVideo();
    front.fixInputAgencyFirefox();
    front.fixInfoBulleScroll();
    front.hideBtnThanksPage();
    front.megamenuBehavior();

    //fonctions spécifiques à certaines pages
    let url = window.location;
    switch (true) {
        case url.pathname === "/": //Home
        case url.pathname === "/webdomaliance/":
            front.swiperRole();
            tool.waitForElem("#form-field-communeHome").then((e) => {
                e.addEventListener("input", function () {
                    if (e.value.length > 3) {
                        new SL.StoreLocatorBehavior("#form-field-communeHome", "#submit-button");
                    }
                });
            });
            geoLoc.inputGeoLocalisation();
            break;
        case url.pathname.includes("/nos-services/"): //Menage
            front.mediaCarousel();
            tool.waitForElem("#form-field-communeHome").then((e) => {
                e.addEventListener("input", function () {
                    if (e.value.length > 3) {
                        new SL.StoreLocatorBehavior("#form-field-communeHome", "#submit-button");
                    }
                });
            });
            break;
        case url.pathname.includes("/demander-votre-devis/"):
        case url.pathname.includes("/devis-offre-speciale/"):
            front.closeTelMenuMobile();
            front.handleRightContentWidthDemandeDeDevis();
            break;
        case url.pathname.includes("/engagement-qualite/"): //Engament qualité
            tool.waitForElem("#form-field-communeHome").then((e) => {
                e.addEventListener("input", function () {
                    if (e.value.length > 3) {
                        new SL.StoreLocatorBehavior("#form-field-communeHome", "#submit-button");
                    }
                });
            });
            geoLoc.inputGeoLocalisation();
            break;
        case url.pathname.includes("/credit-impot-femme-de-menage/"): //Crédit d'impôt femme de ménage
            tool.waitForElem("#form-field-communeHome").then((e) => {
                e.addEventListener("input", function () {
                    if (e.value.length > 3) {
                        new SL.StoreLocatorBehavior("#form-field-communeHome", "#submit-button");
                    }
                });
            });
            geoLoc.inputGeoLocalisation();
            break;
        case url.pathname.includes("/blog/"): //Blog
            front.simulateClickSummaryBlog();
            front.overrideScrollTableOfContents();
            break;
        case url.pathname.includes("/plan-de-site/"): //Plan de site
            front.removeCategoyLinkSitemap();
            break;
        case url.pathname.includes("/formulaire-contact/"): //Formulaire de contact
        case url.pathname.includes("/webdomaliance/formulaire-contact/"):
            tool.waitForElem('#zipcode').then(() => {
                let formField = '#zipcode';
                new SL.StoreLocatorBehavior(formField, null);
            });
            break;
        case url.pathname.includes("/temoignages/"): //témoinages
            tool.waitForElem("#addressInput_avis").then(() => {
                new SL.StoreLocatorBehavior("#addressInput_avis", null);
            });
            break;
        case url.pathname.includes("/simulateur-eligibilite-aici/"):
            FSM.initializeForm();
            break;
        default:
            break;
    }
});
